import { foundationApi } from '@/api/client';

/**
 * Result of verifying an impersonation token with @mgmt. @mgmt decrypts the
 * DataCentral-minted token server-side (shared company encryption SDK) and,
 * when valid, returns who is impersonating this session.
 */
export interface ImpersonationVerifyResult {
  valid: boolean;
  impersonator?: { id: number; name: string; email: string };
  contact_id?: number;
  customer_id?: number;
  reason?: string;
}

/**
 * Verify the encrypted impersonation token against @mgmt. Returns the trusted
 * impersonator identity, or `{ valid: false }` for a bad/expired/foreign token.
 * The @mgmt envelope is `{ status, data }`, so the result lives under `data`.
 */
export async function verifyImpersonation(
  token: string,
): Promise<ImpersonationVerifyResult> {
  const res = await foundationApi.post('/impersonation/verify', { token });
  return res.data?.data ?? { valid: false };
}
